import React, { useEffect, useState, useCallback } from 'react'
import request from '../../../../Helpers/API';
import Swal from 'sweetalert2';
import PlantillaScreen from '../../../helpers/PlantillaScreen';
import { Button } from '@mui/material';
import { LoaderScreen } from '../../../components/LoaderScreen';
import CreateIcon from '@mui/icons-material/Create';
import { ButtonBack } from '../Util/ButtonBack';
import AddIcon from '@mui/icons-material/Add';
import { GrupoActividadModal } from './GrupoActividadModal';

export const CatalogoGrupoActividadesScreen = () => {

    const [data, setData] = useState([]);
    const [modal, setModal] = useState({ open: false, editId: null });

    const [loader, setLoader] = useState({
        mostrar: false,
        alerta: false,
        error: false,
        mensaje: "",
    });

    const cargarListado = useCallback(() => {
        setLoader(prev => ({ ...prev, mostrar: true }));

        request
            .get(`GrupoActividades/listado`)
            .then((result) => {
                const ordenado = result.sort(
                    (a, b) => a.idgrupoactividades - b.idgrupoactividades
                );
                setData(ordenado);
                setLoader(prev => ({ ...prev, mostrar: false }));
            })
            .catch((error) => {
                setLoader(prev => ({ ...prev, mostrar: false }));
                Swal.fire("ERROR", "No se pudo cargar el listado", "error");
            });
    }, []);

    useEffect(() => {
        cargarListado();
    }, [cargarListado]);

    const onAgregar = () => setModal({ open: true, editId: null });
    const onEditar = (id) => setModal({ open: true, editId: id });
    const onCerrarModal = () => setModal({ open: false, editId: null });

    return (
        <PlantillaScreen
            titulo={"CATALOGO GRUPO DE ACTIVIDADES"}
            className_main={1}
            className={"seguimiento-actividades-contenedor"}
        >

            <LoaderScreen loader={loader} />

            <div className='sac-contenido'>

                <div className='sacc-agregar'>
                    <Button
                        variant="contained"
                        onClick={onAgregar}
                    >
                        <AddIcon/>
                        Agregar
                    </Button>
                </div>

                <div className="sacc-tabla sacc-tabla-grupoAct scroll">

                    <table className="sacct-container">
                        <thead>
                            <tr>
                                <th>ID</th>
                                <th>NOMBRE</th>
                                <th>ESTADO</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {data.map((grupo) => (
                                <tr key={grupo.idgrupoactividades}>
                                    <td><span className="sacct-id-chip">{grupo.idgrupoactividades}</span></td>
                                    <td>{grupo.nombregrupoactividades}</td>
                                    <td>
                                        <span className={`status-badge ${grupo.estado ? "status-badge--activo" : "status-badge--inactivo"}`}>
                                            {grupo.estado ? "ACTIVO" : "INACTIVO"}
                                        </span>
                                    </td>
                                    <td className='sa-editar'>
                                        <CreateIcon
                                            style={{ cursor: "pointer", color: "#ed7d31" }}
                                            onClick={() => onEditar(grupo.idgrupoactividades)}
                                        />
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>

            <GrupoActividadModal
                open={modal.open}
                editId={modal.editId}
                onClose={onCerrarModal}
                onSaved={cargarListado}
            />

            <ButtonBack path={'/Permisos/Main'} ></ButtonBack>
        </PlantillaScreen>
    );
}
